/**
 * Coaches list (for pickers in scheduling modals).
 * GET /actions/coaches — proxies upstream `coaches` and returns a trimmed
 *   list of `{ _id, name, email, profile_image_url }` sorted by name.
 *   Optional `?name=foo` is forwarded as a server-side filter; if unsupported
 *   upstream the client can also filter the returned array.
 */
const Coaches = (app) => {
  app.get("/coaches", async ({ req, res, api }) => {
    try {
      const name =
        typeof req.query?.name === "string" ? req.query.name.trim() : "";
      const query = {
        ...(name ? { name } : {}),
        limit: false,
        sort: { name: 1 },
      };
      const response = await api("coaches", { query });
      if (!response.ok) {
        res.status = response.status;
        res.body = await response.text();
        return;
      }
      const body = await response.json();
      const list = Array.isArray(body?.coaches)
        ? body.coaches
        : Array.isArray(body)
          ? body
          : [];
      const trimmed = list
        .map((c) => ({
          _id: String(c?._id ?? c?.id ?? ""),
          name: String(c?.name ?? "").trim(),
          email: String(c?.email ?? "").trim(),
          avatar:
            c?.avatar && typeof c.avatar === "object" && c.avatar.s3Path
              ? { s3Path: String(c.avatar.s3Path) }
              : null,
          profile_image_url:
            typeof c?.profile_image_url === "string"
              ? c.profile_image_url
              : typeof c?.avatar === "string"
                ? c.avatar
                : "",
        }))
        .filter((c) => c._id && c.name);

      res.headers = res.headers || {};
      res.headers["Content-Type"] = "application/json; charset=utf-8";
      res.status = 200;
      res.body = JSON.stringify({ coaches: trimmed });
    } catch (e) {
      res.status = 500;
      res.headers = res.headers || {};
      res.headers["Content-Type"] = "application/json; charset=utf-8";
      res.body = JSON.stringify({
        error: e?.message || "Failed to load coaches",
      });
    }
  });
};

export default Coaches;
